import React, { Component } from 'react';

import { DashboardConsumer } from '../../layouts/PanelLayoutContext';

/**
 * Sidebar Component
 * Main sidebar container for navigation
 */
export default class Sidebar extends Component {
    render() {
        return (
            <DashboardConsumer>
                {DashboardState => {
                    const isOpen = DashboardState.sidebarState === 1;
                    return (
                        <div
                            className={`fixed top-16 left-0 z-[101] flex flex-col w-[280px] h-[calc(100vh-64px)] 
                                bg-[#0f1115]/95 backdrop-blur-xl border-r border-white/[0.06] shadow-[4px_0_24px_-12px_rgba(0,0,0,0.5)]
                                transition-transform duration-300 ease-[cubic-bezier(0.2,0.8,0.2,1)]
                                ${isOpen ? 'translate-x-0' : '-translate-x-full'}
                            `}
                        >
                            {/* Scrollable Content */}
                            <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden py-4 custom-scrollbar">
                                <ul className="flex flex-col gap-1 px-3 list-none m-0">
                                    {this.props.children}
                                </ul>
                            </div>

                            {/* Footer */}
                            <div className="flex-none p-4 border-t border-[#ffffff14] bg-[#121317]/80 backdrop-blur-md">
                                <div className="flex items-center justify-center">
                                    <span className="text-[11px] font-normal text-gray-500 hover:text-gray-300 transition-colors">
                                        © 2026, Coded by <a href="https://lysep.com" className="text-[#fd7000] hover:text-[#ff8c33] hover:underline transition-all">LYSEP</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </DashboardConsumer>
        );
    }
}
